import { render, staticRenderFns } from "./guessing-item-gold.vue?vue&type=template&id=172f8e24&scoped=true&"
import script from "./guessing-item-gold.vue?vue&type=script&lang=js&"
export * from "./guessing-item-gold.vue?vue&type=script&lang=js&"
import style0 from "./guessing-item-gold.vue?vue&type=style&index=0&id=172f8e24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172f8e24",
  null
  
)

export default component.exports